var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrintSharpRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "print-sharp-regular 1",
    clipPath: "url(#clip0_3091_10938)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.5 5V1.5H11.3781L12.5 2.62188V5H14V2L12 0H3.5H2V1.5V5H3.5ZM12 11.5V14.5H4V11.5H12ZM4 10H2.5V11H1.5V7.5H14.5V11H13.5V10H12H4ZM13.5 12.5H14.5H16V11V7.5V6H14.5H1.5H0V7.5V11V12.5H1.5H2.5V14.5V16H4H12H13.5V14.5V12.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3091_10938"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintSharpRegular);
export default __webpack_public_path__ + "static/media/print-sharp-regular.d4aa59a0c57b753eb173f11bc544077d.svg";
export { ForwardRef as ReactComponent };